<template>
    <div class="col-lg-10 col-md-8 col-12 main">
        <YouTubeEmbed videoId="N30UI7KLP-I" :lazy="true" :useApi="false" />
    </div>
</template>
<script>
import YouTubeEmbed from "@/components/YouTubeEmbed.vue";
export default {
    name: "home",
    components: {
         YouTubeEmbed
    },
    data() {
        return {
            list: [
            ],
        }
    },


};
</script>
<style scoped>
/* 
*{border:1px solid #000;} */

.main {
    height: 100vh;
    padding: 30px 15px;
}

@media (max-width: 768px) {
    .main {
        padding-top: 0px;
        height: calc(100vh - 90px);
    }

}
</style>